export default "__VITE_ASSET__Ci2kJYzT__"